var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpartanLaser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.173 10.9218H104.81L103.768 11.5968C103.768 11.5968 103.543 12.2163 103.43 12.2163H100.22L100.051 11.5968L99.4884 10.9218H92.1684L81.6939 12.6108H57.8454L55.6674 12.9603L54.5589 14.2443L50.1024 14.4123L49.9899 15.5943L46.7664 15.6093L46.2009 13.7898L45.1344 13.1163H37.2849L35.9124 12.2148H29.4369L28.5354 12.7218H26.2824L25.5789 12.2148L22.6989 12.2823L9.4164 18.3558L7.7769 19.2708L7.3344 20.1573V25.9008L11.3604 26.0703L12.5994 25.3668L13.8939 26.0433L16.1469 26.2398C16.1469 26.2398 16.0344 26.9718 15.9774 27.1128C15.9204 27.2538 8.3469 27.2538 8.3469 27.2538L8.1504 28.9428H3.4209L2.6709 29.5743C2.6709 29.5743 2.7819 30.6813 2.8239 30.7488C2.8674 30.8163 4.2579 32.5038 4.2579 32.5038L10.4589 32.4348L11.5014 31.8438H12.6834C12.6834 31.8438 13.0494 33.2523 13.0209 33.4923C12.9924 33.7338 12.3459 35.8128 12.3459 35.8128L13.3314 36.0603L14.8239 33.0543L16.7859 33.1338L17.1039 34.3893L18.0024 34.6953L22.4259 43.5018L22.3974 44.5158C22.3974 44.5158 22.9734 45.1128 23.1009 45.1638C23.2284 45.2148 26.4519 43.1928 26.4669 43.0233C26.4834 42.8538 26.4669 41.9058 26.4669 41.9058L25.8594 41.6448L23.6919 37.5483C23.6919 37.5483 23.0964 35.6778 22.8969 34.8588C22.6974 34.0413 24.1149 33.5913 24.1149 33.5913L28.7049 33.6138L29.6904 33.9048C29.6904 33.9048 29.4639 34.8018 29.4639 34.8588C29.4639 34.9158 29.9154 36.2943 29.9154 36.2943L31.8024 36.9138L33.7644 39.3198H41.8269C41.8269 39.3198 42.9909 40.0848 43.5579 40.6758C44.1249 41.2653 45.3384 43.0818 45.4854 43.3488C45.6324 43.6158 45.8814 44.6013 45.8814 44.6013L46.0749 45.5778L46.8954 45.9588L50.5554 45.9783L51.0339 45.6723L52.0329 44.9328L52.9194 44.5173H56.8899L58.0239 44.7648L58.7484 45.7833H60.8319L61.7049 45.6708L69.2784 45.4458L70.1514 44.3193H70.8834L72.5709 40.7133L73.3479 40.5753L74.6754 39.4293L75.1374 38.1108L75.4419 35.3658L76.2369 33.5043L77.7654 32.2713L79.1469 31.5933H94.5339L97.7439 33.3948H103.994L105.281 33.1203C105.281 33.1203 117.835 27.7503 117.904 27.6783C117.973 27.6063 118.298 26.6868 118.298 26.6868V16.1598L113.174 10.9233L113.173 10.9218ZM10.7979 31.1658H9.7284L8.9964 31.6443H5.4204C5.4204 31.6443 4.0119 30.3768 4.5474 30.2358H10.2354L10.7979 30.6018V31.1643V31.1658ZM39.9669 37.2618H35.0259C35.0259 37.2618 33.8859 37.3038 33.8004 36.8388C33.7149 36.3738 33.8004 35.3613 33.8004 35.3613L34.3074 34.8543H38.5734C38.5734 34.8543 39.9669 34.8543 39.9669 35.7828V37.2603V37.2618ZM53.3979 38.0643L51.1179 39.7113C48.8379 41.3583 47.5284 39.7113 47.5284 39.7113C47.5284 39.7113 46.0074 37.8948 45.5019 37.2618C44.9949 36.6288 45.1644 36.2058 45.1644 36.2058L45.8409 34.6428H52.4709C53.7804 34.6428 53.7804 35.6148 53.7804 35.6148L53.8644 36.6708C53.9484 37.7268 53.3994 38.0643 53.3994 38.0643H53.3979Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0881 12.2177V13.9772L25.8341 14.8637H35.5196V12.2177",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0205 27.4217V22.7477H52.6375L53.032 23.3672H55.3975L56.0725 22.7477H59.0005C59.0005 22.7477 59.998 22.8047 59.998 23.8172V27.0557",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3975 23.3672V27.0557",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.541 34.6293L19.027 34.1432H23.203",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6436 30.0002H24.8906V32.6162H40.6436V30.0002Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6436 38.9942V32.6162H46.1756L46.7681 32.8697H54.5381H57.3266V38.5712L55.8896 39.9227V44.5127",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.538 32.8698L56.185 38.1918L48.373 44.2727V45.6662",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8237 36.4172L41.8252 38.9942",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.373 32.8697V30.0002H70.207L71.179 30.6737V33.0392H66.0265",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8183 31.5198H63.1123V37.2633H65.8183V31.5198Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9002 33.0393H60.9997H57.3262",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3955 33.0393V38.5638L60.4545 39.2688V43.3443H59.3955V38.5638",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0859 32.8698V43.3442",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.179 33.0392V41.1902V43.3442H62.9005V38.9942L61 37.7057V33.0392",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1787 41.1903H69.7432V33.0393",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1787 30.6737C71.1787 30.6737 71.9392 28.7732 74.0512 28.7312C76.1632 28.6892 90.1417 28.7312 90.1417 28.7312V31.3502",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5339 28.4478V31.1388",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6133 16.6667H92.1683",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.77 16.4402H106.261L108.331 15.5957V14.5817H113.511L116.578 17.1167",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M117.252 15.0887V17.7362H115.201V18.9752H117.252V21.4802V23.3672H115.201V24.6617H117.252V27.0557L115.426 28.4072",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.945 21.4802H117.252",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.583 16.3998V10.9218",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8832 12.2178V16.0458L95.3232 17.9613V19.9398H95.8302V20.8188H98.8707V19.9398H101.742V17.9613",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.168 19.0878C92.168 19.0878 94.2515 18.8913 94.2515 20.8188H95.321",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7711 11.2037L97.9141 12.2177V14.8082L99.7711 15.3422",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0449 22.7478V21.7488H92.9009C92.9009 21.7488 94.0274 21.9033 94.0274 22.5228V24.7188",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M85.355 21.4802H83.666V23.7047",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5129 17.1168H57.9884L59.1704 16.6683C59.1704 16.6683 59.3399 15.4848 59.1704 14.8653C59.0009 14.2458 58.0439 13.9788 58.0439 13.9788H54.9464L51.2864 16.5198H48.9839V18.2448H51.9614L51.7919 21.5433H46.5059",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1702 14.8638H71.3907",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4653 14.8638V17.1168H57.9883",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3572 19.3127C67.392 19.3127 67.4202 19.1804 67.4202 19.0172C67.4202 18.854 67.392 18.7217 67.3572 18.7217C67.3224 18.7217 67.2942 18.854 67.2942 19.0172C67.2942 19.1804 67.3224 19.3127 67.3572 19.3127Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78.907 25.4508C79.0395 25.4508 79.147 25.3433 79.147 25.2108C79.147 25.0782 79.0395 24.9708 78.907 24.9708C78.7744 24.9708 78.667 25.0782 78.667 25.2108C78.667 25.3433 78.7744 25.4508 78.907 25.4508Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.001 15.6122C45.0755 15.6122 45.136 15.5518 45.136 15.4772C45.136 15.4027 45.0755 15.3422 45.001 15.3422C44.9264 15.3422 44.866 15.4027 44.866 15.4772C44.866 15.5518 44.9264 15.6122 45.001 15.6122Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.096 18.1937C37.2012 18.1937 37.2865 18.1085 37.2865 18.0032C37.2865 17.898 37.2012 17.8127 37.096 17.8127C36.9908 17.8127 36.9055 17.898 36.9055 18.0032C36.9055 18.1085 36.9908 18.1937 37.096 18.1937Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7135 34.3863C42.8477 34.3863 42.9565 34.2775 42.9565 34.1433C42.9565 34.0091 42.8477 33.9003 42.7135 33.9003C42.5793 33.9003 42.4705 34.0091 42.4705 34.1433C42.4705 34.2775 42.5793 34.3863 42.7135 34.3863Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3951 31.5197C59.5119 31.5197 59.6066 31.425 59.6066 31.3082C59.6066 31.1914 59.5119 31.0967 59.3951 31.0967C59.2783 31.0967 59.1836 31.1914 59.1836 31.3082C59.1836 31.425 59.2783 31.5197 59.3951 31.5197Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7435 31.5197C69.8603 31.5197 69.955 31.425 69.955 31.3082C69.955 31.1914 69.8603 31.0967 69.7435 31.0967C69.6267 31.0967 69.532 31.1914 69.532 31.3082C69.532 31.425 69.6267 31.5197 69.7435 31.5197Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2726 30.0002C19.3902 30.0002 19.4856 29.9049 19.4856 29.7872C19.4856 29.6696 19.3902 29.5742 19.2726 29.5742C19.1549 29.5742 19.0596 29.6696 19.0596 29.7872C19.0596 29.9049 19.1549 30.0002 19.2726 30.0002Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9386 22.2273L38.8701 23.3673",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8719 24.6348H51.1179",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2591 24.6348H46.7676",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0131 22.7478C96.0985 22.7478 96.1676 22.6786 96.1676 22.5933C96.1676 22.508 96.0985 22.4388 96.0131 22.4388C95.9278 22.4388 95.8586 22.508 95.8586 22.5933C95.8586 22.6786 95.9278 22.7478 96.0131 22.7478Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8421 18.1518C98.9473 18.1518 99.0326 18.0665 99.0326 17.9613C99.0326 17.856 98.9473 17.7708 98.8421 17.7708C98.7369 17.7708 98.6516 17.856 98.6516 17.9613C98.6516 18.0665 98.7369 18.1518 98.8421 18.1518Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.741 13.4283C101.827 13.4283 101.896 13.3591 101.896 13.2738C101.896 13.1884 101.827 13.1193 101.741 13.1193C101.656 13.1193 101.587 13.1884 101.587 13.2738C101.587 13.3591 101.656 13.4283 101.741 13.4283Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43308 18.8055L22.8496 12.2175H25.7776V12.7245H28.6501L29.2696 12.2175H35.9146L37.2091 13.119H45.4306C45.4306 13.119 46.3321 13.4565 46.4446 14.5275L46.5571 15.597L49.3171 15.513C49.3171 15.513 50.1061 15.7665 50.1061 16.2735V14.3025L54.6106 14.2455C54.6106 14.2455 55.1176 12.612 57.0316 12.612H81.6961L92.1706 10.923H99.4906L100.053 11.4855V12.2175H103.658V11.7105C103.658 11.7105 103.883 10.9215 105.066 10.9215H113.175L118.299 16.158V26.238C118.299 26.238 118.469 27.477 117.51 27.984C116.552 28.491 104.615 33.39 104.615 33.39H97.7446L94.6471 31.5885H79.1056C79.1056 31.5885 76.7971 32.5455 76.1206 33.672C75.4441 34.7985 75.1636 36.432 75.1636 37.2765C75.1636 38.121 75.1636 38.9655 74.4886 39.642C73.8136 40.3185 73.1941 40.881 72.6301 40.599L71.1091 43.4715L71.0521 44.316H70.1506L69.4756 45.4425H61.5361V45.78H58.7491L57.8476 44.5125H53.7646C53.7646 44.5125 52.5541 44.3715 51.9346 45.0195C51.3151 45.6675 51.0616 45.8925 50.2171 45.948C49.3726 46.0035 46.5856 45.948 46.5856 45.948C46.5856 45.948 45.8251 45.864 45.8821 44.5965C45.9391 43.329 43.4611 40.4295 42.8416 39.951C42.2221 39.4725 41.7991 39.303 41.7991 39.303L33.7186 39.219L31.8046 36.9105L30.8191 36.882V35.9805H30.1996C30.1996 35.9805 30.0586 36.7695 29.7496 36.8535C29.4406 36.9375 29.4676 34.686 29.4676 34.686C29.4676 34.686 30.1711 34.4325 29.7496 33.6165L24.1186 33.588C24.1186 33.588 23.1046 33.87 22.9081 34.686C22.7116 35.502 25.4701 41.106 25.4701 41.106L26.5681 41.979L26.4556 43.1895L23.1046 45.1605C23.1046 45.1605 22.2886 44.991 22.4296 43.5L18.2626 35.109L18.5446 34.6305L17.1091 34.8V33.618C17.1091 33.618 17.0521 33.027 16.3486 33.027C15.6451 33.027 14.8276 33.0555 14.8276 33.0555L13.5046 36.153L12.3496 35.8155L13.0531 33.3945V31.8465H11.7301L10.8571 32.5785L5.14208 32.6355C5.14208 32.6355 4.26908 32.8605 3.62108 31.932C2.97308 31.0035 2.71958 30.5805 2.71958 30.5805C2.71958 30.5805 2.10008 29.088 3.67658 29.088C5.25308 29.088 8.15408 29.0595 8.15408 29.0595V27.258H16.1506V26.0475H13.5886C13.5886 26.0475 13.2796 25.3725 12.6031 25.3725C11.9266 25.3725 11.7016 26.076 11.7016 26.076H7.33808V20.163C7.33808 20.163 7.42508 19.2735 8.43608 18.8115L8.43308 18.8055Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1494 26.0416H37.1389L46.1344 21.7621C46.1344 21.7621 46.7674 21.5926 46.7674 20.8966V19.9891H44.2129V17.9191H46.7674V15.5956",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15234 29.0552H12.3763C12.3763 29.0552 13.4188 29.0837 13.6708 29.2802H17.7253C17.7253 29.2802 17.5843 28.2947 18.5698 28.2947H21.3298L21.9493 27.9002H24.9898C24.9898 27.9002 25.8058 28.1252 25.8058 28.8017H33.7183L34.6198 29.7872H40.9543L41.5453 29.5622V28.6892L44.1913 27.4217H51.8218L52.3288 27.0557H62.4928C62.4928 27.0557 61.9018 23.1422 66.1528 23.1422H71.7283L73.2763 23.9312H73.8673V27.3662H77.4433C77.4433 27.3662 78.3448 27.4787 78.7108 28.0697H102.531L105.628 26.4647H88.3409L83.8363 23.9312H73.8688",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M105.629 26.4646H108.219L112.329 28.4071H116.579",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33496 21.4876L29.4945 21.3751L31.458 20.8186H46.7685",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8389 34.6426L45.1639 36.2056C45.1639 36.2056 44.9944 36.6286 45.5014 37.2616C46.0084 37.8946 47.5279 39.7111 47.5279 39.7111C47.5279 39.7111 48.8374 41.3581 51.1174 39.7111L53.3974 38.0641C53.3974 38.0641 53.9464 37.7266 53.8624 36.6706L53.7784 35.6146C53.7784 35.6146 53.7784 34.6426 52.4689 34.6426H45.8389Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8024 35.3611L34.3094 34.8541H38.5754C38.5754 34.8541 39.9689 34.8541 39.9689 35.7826V37.2601H35.0279C35.0279 37.2601 33.8879 37.3021 33.8024 36.8371C33.7169 36.3721 33.8024 35.3596 33.8024 35.3596V35.3611Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54823 30.2371H10.2362L10.7987 30.6031V31.1656H9.72923L8.99723 31.6441H5.42123C5.42123 31.6441 4.01273 30.3766 4.54823 30.2356V30.2371Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7305 10.9216V14.7511L92.169 16.7776V19.0861C92.169 19.0861 89.916 18.8896 89.916 20.8171H85.6365V22.1821L90.648 24.9976H109.425",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M109.425 24.9992C111.369 24.9992 112.944 23.4237 112.944 21.4802C112.944 19.5367 111.369 17.9612 109.425 17.9612C107.482 17.9612 105.906 19.5367 105.906 21.4802C105.906 23.4237 107.482 24.9992 109.425 24.9992Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.425 17.9611H101.742V17.2291L103.77 16.4401V12.2176",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M106.261 19.9396L112.528 23.1421",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1386 16.6097L70.1231 15.3422H84.3566C84.3566 15.3422 85.6376 15.4262 85.6376 16.4402C85.6376 17.4542 84.3986 17.4542 84.3986 17.4542H68.6456C68.6456 17.4542 67.8851 17.5382 68.1386 16.6097Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6006 12.6106V15.3421",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6006 17.4557V23.1422",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpartanLaser);
export default __webpack_public_path__ + "static/media/Spartan Laser.d3b53e4e582d0bd5078b0ddeba4a5279.svg";
export { ForwardRef as ReactComponent };